<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商户信息</el-breadcrumb-item>
      <el-breadcrumb-item>基础信息</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-form ref="form" :model="form" label-width="150px">
        <el-form-item label="商户名称">
          <el-input disabled  v-model="form.merchantName"></el-input>
        </el-form-item>
        <el-form-item label="商户手机">
          <el-input disabled v-model="form.merchantPhone"></el-input>
        </el-form-item>
        <el-form-item label="商户地址">
          <el-input disabled v-model="form.merchantAddress"></el-input>
        </el-form-item>
        <el-form-item label="商户余额">
          <el-input disabled v-model="form.balanceAmount"></el-input>
        </el-form-item>
        <el-form-item label="可使用优惠券金额">
          <el-input disabled v-model="form.couponMoneyList"></el-input>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  created () {
    this.getMerchantInfo()
  },
  data () {
    return {
      form: {
        merchantId: '',
        merchantName: '',
        merchantPhone: '',
        merchantAddress: '',
        balanceAmount: '',
        couponMoneyList: ''
      }
    }
  },
  methods: {
    // 获取商户信息
    async getMerchantInfo () {
      const token = window.sessionStorage.getItem('token')
      if (undefined === token || token === '') { // 判断用户登录是否有效
        this.$message.error('您的登录已失效，请重新登录')
        window.sessionStorage.clear()
        this.$router.push('/login')
      }
      const { data: res } = await this.$http.get('queryMerchantInfoByToken', { headers: { token: token } })
      // console.log(res)
      if (res.code === '0') {
        this.form.merchantId = res.data.merchantId
        this.form.merchantName = res.data.merchantName
        this.form.merchantPhone = res.data.merchantPhone
        this.form.merchantAddress = res.data.merchantAddress
        this.form.balanceAmount = res.data.balanceAmount
        this.form.couponMoneyList = res.data.couponMoneyList
      } else {
        return this.$message.error(res.message)
      }
    }
  },
  computed: {}
}
</script>

<style lang="less" scoped>
</style>
